"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const commodities = [{
  title: "Neuro-Sensory Training",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689046/img/neuro_sensory_training.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689046/img/neuro_sensory_training.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689046/img/neuro_sensory_training.png-wvc-sizes",
  alt: "Athlete undergoing neuro-sensory assessment",
  link: "/HomePage"
}, {
  title: "Movement Assessment",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689046/img/movement_assessment_analysis.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689046/img/movement_assessment_analysis.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689046/img/movement_assessment_analysis.png-wvc-sizes",
  alt: "Professional movement analysis session",
  link: "/HomePage"
}, {
  title: "One-on-One Treatment",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689046/img/individual_performance_treatment.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689046/img/individual_performance_treatment.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689046/img/individual_performance_treatment.png-wvc-sizes",
  alt: "Personalized clinical treatment session",
  link: "/HomePage"
}];
export default function OurPerformancePillars() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="255644" id="our-performance-pillars" className="bg-background text-foreground py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 max-w-3xl border-t border-primary/10 pt-12">
          <h2 className="text-3xl md:text-5xl font-black font-default text-foreground mb-4 tracking-wider uppercase">
            Our Performance Pillars
          </h2>
          <p className="text-lg text-muted-foreground font-default uppercase tracking-wide">
            Targeted methodologies to reduce pain and optimize athletic potential.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-6 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {commodities.map((item, i) => <Link key={i} to={item.link} data-index={i} className="block group">
              <Card className="overflow-hidden border-0 rounded-md shadow-md group-hover:shadow-lg transition-all duration-500 p-0 bg-muted relative">
                <AspectRatio ratio={1}>
                  <div className="relative w-full h-full overflow-hidden rounded-md pt-12">
                    <img src={item.src} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105 opacity-90" />
                    {}
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-5 transition-opacity duration-700 pointer-events-none">
                       <div className="w-64 h-64 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689046/img/logo_silhouette.png')] bg-contain bg-no-repeat bg-center" />
                    </div>
                    
                    <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/20 to-transparent pointer-events-none" />
                    
                    <h3 className="absolute bottom-6 left-6 right-6 text-foreground font-bold text-2xl md:text-3xl font-default leading-tight uppercase tracking-tight">
                      {item.title.split(' ').map((word, idx) => <span key={idx} className={word.toLowerCase() === 'performance' ? 'text-primary italic' : ''}>
                          {word}{' '}
                        </span>)}
                    </h3>
                  </div>
                </AspectRatio>
              </Card>
              <div className="mt-4 h-px bg-primary/10 w-full" />
            </Link>)}
        </div>
      </div>
    </section>;
}